/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 * 
 */
let baseUrl = '/doctor';
let routerMode = 'history';
let baseImgPath = "https://mingyu-dev.linker-go.cn/";
let uploadPath = baseUrl;

if (process.env.NODE_ENV == 'development') {
    baseImgPath = 'https://mingyu-dev.linker-go.cn/';
} else {
    baseImgPath = 'https://mingyu-dev.linker-go.cn/';
}

export {
    baseUrl,
    routerMode,
    baseImgPath,
    uploadPath
}



// WEBPACK FOOTER //
// ./src/config/env.js